import { Module } from 'vuex';

interface TranslationStoreState {
  currentLanguage: String;
  languages: {};
}

export const translationStore: Module<TranslationStoreState, any> = {
  state: {
    currentLanguage: localStorage.getItem('currentLanguage') || 'cs',
    languages: {
      cs: { name: 'Český' },
      en: { name: 'English' }
    }
  },
  getters: {
    currentLanguage: state => state.currentLanguage,
    languages: state => state.languages
  },
  mutations: {
    currentLanguage(state, newLanguage) {
      state.currentLanguage = newLanguage;
      localStorage.setItem('currentLanguage', newLanguage);
    }
  }
};
